import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { fetchCommunicationsSituations, fetchedCommunicationsSituations } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

export function* getSituationsCommunicationsSaga() {
  const { getCommunicationsSituations } = getAPI();
  const response: YieldOf<typeof getCommunicationsSituations> = yield call(getCommunicationsSituations);
  const { data, ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedCommunicationsSituations(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedCommunicationsSituations(undefined, error));
  }
}

export default function* situationsSaga() {
  yield takeLatest(fetchCommunicationsSituations.type, getSituationsCommunicationsSaga);
}
